module.exports = __webpack_public_path__ + "static/media/tg.29fa137c.svg";